__turbopack_context__.v({
  "table": "DataTable-module__oARv5a__table",
  "wrap": "DataTable-module__oARv5a__wrap",
});
